module.exports = __webpack_public_path__ + "static/media/location-5.3302f1ed.jpg";